module.exports = __webpack_public_path__ + "static/media/Bon Adriel Aseniero.f768f9e9.png";